import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
} from '@tonic-one/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const EditTipModal = (props: any) => {
  const { visible, onClose, onConfirm, dataList } = props;
  const { t } = useTranslation();
  console.log(dataList);
  const useToggle = (defaultValue: boolean) => {
    const [value, setValue] = useState(defaultValue);
    const toggle = () => setValue((value) => !value);
    return [value, toggle];
  };

  const [isOverlayVisible] = useToggle(true);

  return (
    <Modal
      ensureFocus={false}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={visible}
      onClose={onClose}
      size="sm"
    >
      {isOverlayVisible && <ModalOverlay opacity={0.6} />}
      <ModalContent minHeight="200px">
        <ModalBody>
          {dataList.scope.mitigationAccounts && !dataList.status ? (
            <Text mb={8}>
              {t('administration.apiToken.edit.content', {
                apiType: t(
                  'administration.apiToken.table.scopeName.mitigation'
                ),
              })}
              <br />
              {t('administration.apiToken.tip.content')}
            </Text>
          ) : (
            <Text mb="8x">{t('administration.apiToken.edit.changeScope')}</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            minWidth="20x"
            onClick={() => {
              onConfirm(dataList);
            }}
          >
            {t('common.button.ok')}
          </Button>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default EditTipModal;
